import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { ApiConnectionService } from 'src/app/services/core/api-connection.service';

@Component({
  selector: 'app-modal-portfolio-overview',
  templateUrl: './modal-portfolio-overview.component.html',
  styleUrls: ['./modal-portfolio-overview.component.scss']
})
export class ModalPortfolioOverviewComponent implements OnInit {

  @Input() public portfolioId: string = '';
  @Input() public lessonTitle: string = '';

  loading = true;
  portfolioPDFUrl:SafeResourceUrl = ''

  portfolioData: any = {
    "item": []
  };

  formatDate(datetimeStr) {
    // Create an array of month names in the desired language (e.g., Dutch)
    const months = ["januari", "februari", "maart", "april", "mei", "juni",
      "juli", "augustus", "september", "oktober", "november", "december"];

    // Parse the datetime string
    const dateObj = new Date(datetimeStr);

    // Extract the day, month, and year
    const day = dateObj.getDate();
    const monthIndex = dateObj.getMonth(); // Note: getMonth() returns 0-based month index
    const year = dateObj.getFullYear();

    // Format the output string
    const formattedDate = `${day} ${months[monthIndex]} ${year}`;

    return formattedDate;
  }

  constructor(public activeModal: NgbActiveModal, public apiService: ApiConnectionService, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.portfolioPDFUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://api.methodem.dev/users/portfolioPdf/' + this.portfolioId + '/&base64=1#toolbar=0&navpanes=0');

    setTimeout(() => {
      this.submit();
    }, 100);
  }

  async submit(download = false) {
    const form:HTMLFormElement = document.querySelector('#NameInputForm');
    const formData = new FormData(form);

    const response = await this.apiService.post('users/portfolioPdf/&base64=1',formData);
    const result = await response.text();
    
    const byteCharacters = atob(result);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf'});
    const blobURL = URL.createObjectURL(blob);

    if (download === true) {
      const date = new Date();
      
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
    
      const dateString = `${day}-${month}-${year}`;
    
      const link = document.createElement('a');
      link.href = blobURL;
      link.download = 'portfolio-' + dateString + '.pdf';
      document.body.appendChild(link);
      
      link.click();
    
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
      return;
    }

    const pdfIframe:HTMLIFrameElement = document.querySelector('#portfolioPDF');
    pdfIframe.src = blobURL + '#toolbar=0&navpanes=0';

    await this.awaitIframeLoad();
    this.loading = false;
  }

  downloadPDF() {
    this.submit(true);
  }
  printPDF() {
    let printIframe = document.getElementById('portfolioPDF');
    if (printIframe instanceof HTMLIFrameElement) {
      printIframe.contentWindow.focus();
      printIframe.contentWindow.print();
    }
  }

  awaitIframeLoad() {
    return new Promise<void>((resolve, reject) => {
      const iframe = document.getElementById('portfolioPDF');
      if (iframe instanceof HTMLIFrameElement) {
        iframe.addEventListener('load', () => {
          resolve();
        });
      }
    });
  }

  close() {
    this.activeModal.close(false);
  }
}
